import type {HTMLAttributes} from 'react';

export interface AiChatChristmasGiftGlint {
  leftPercent: number;
  topPercent: number;
  delaySeconds: number;
}

export const AI_CHAT_CHRISTMAS_GIFT_GLINTS: AiChatChristmasGiftGlint[] = [
  {leftPercent: 28, topPercent: 18, delaySeconds: 0.4},
  {leftPercent: 70, topPercent: 26, delaySeconds: 1.7},
  {leftPercent: 52, topPercent: 50, delaySeconds: 2.6},
];

export interface AiChatChristmasGiftBurst {
  leftPercent: number;
  topPercent: number;
}

export interface AiChatChristmasGiftSpark {
  driftXPx: number;
  riseYPx: number;
  sizePx: number;
}

export const GIFT_UNLOCK_DELAY_MS = 650;

export const AI_CHAT_CHRISTMAS_GIFT_BURSTS: AiChatChristmasGiftBurst[] = [
  {leftPercent: 30, topPercent: 4},
  {leftPercent: 55, topPercent: -4},
  {leftPercent: 78, topPercent: 8},
  {leftPercent: 44, topPercent: 18},
];

export const AI_CHAT_CHRISTMAS_GIFT_SPARKS: AiChatChristmasGiftSpark[] = [
  {driftXPx: -70, riseYPx: 46, sizePx: 12},
  {driftXPx: -40, riseYPx: 58, sizePx: 16},
  {driftXPx: -14, riseYPx: 50, sizePx: 20},
  {driftXPx: 12, riseYPx: 62, sizePx: 12},
  {driftXPx: 38, riseYPx: 52, sizePx: 16},
  {driftXPx: 66, riseYPx: 44, sizePx: 20},
  {driftXPx: -55, riseYPx: 30, sizePx: 12},
  {driftXPx: 52, riseYPx: 32, sizePx: 16},
  {driftXPx: 0, riseYPx: 36, sizePx: 20},
  {driftXPx: -28, riseYPx: 40, sizePx: 12},
  {driftXPx: 26, riseYPx: 42, sizePx: 16},
  {driftXPx: 80, riseYPx: 30, sizePx: 20},
];

export type AiChatChristmasGiftsAccessibilityProps = Pick<HTMLAttributes<HTMLDivElement>, 'tabIndex' | 'aria-hidden' | 'aria-label' | 'onKeyDown'>;
